import { FC, JSX } from 'react';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import Divider from '@mui/joy/Divider';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import DialogActions from '@mui/joy/DialogActions';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { Loader } from '../Loader/Loader';
import './AlertModal.scss';

type ModalProps = {
  open: boolean;
  setOpen: (val: boolean) => void;
  alertTitle: string;
  alertMessage: string;
  alertAction: () => void;
  alertActionText: string;
  alertCancelText: string;
  isLoading?: boolean;
  btnType?: 'success' | 'danger';
  /** Optional informational note rendered below the message */
  alertNote?: string;
};

export const AlertModal: FC<ModalProps> = ({
  open,
  setOpen,
  alertTitle,
  alertMessage,
  alertAction,
  alertActionText,
  alertCancelText,
  isLoading,
  btnType = 'danger',
  alertNote,
}): JSX.Element => {
  return (
    <Modal
      className="consolidate-modal"
      open={open}
      onClose={() => setOpen(false)}
    >
      <ModalDialog variant="outlined" role="alertdialog">
        <DialogTitle>
          <WarningRoundedIcon />
          {alertTitle}
        </DialogTitle>
        <Divider />
        <DialogContent>{alertMessage}</DialogContent>
        {alertNote && (
          <Box className="alert-modal-note">
            <InfoOutlinedIcon fontSize="small" />
            <span>{alertNote}</span>
          </Box>
        )}
        <DialogActions>
          <Button
            variant="solid"
            color={btnType}
            style={{ minWidth: '76px' }}
            onClick={(e) => {
              e.stopPropagation();
              alertAction();
            }}
          >
            {isLoading ? <Loader /> : alertActionText}
          </Button>
          <Button
            variant="plain"
            color="neutral"
            onClick={(e) => {
              e.stopPropagation();
              setOpen(false);
            }}
          >
            {alertCancelText}
          </Button>
        </DialogActions>
      </ModalDialog>
    </Modal>
  );
};
